import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { UrlService } from '@service/url/url.service';
import { CarrierService } from '@service/carrier/carrier.service';
import { UtilService } from '@service/util/util.service';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-carrier-autocomplete',
	templateUrl: './carrier-autocomplete.component.html',
	styleUrls: ['./carrier-autocomplete.component.scss'],
})
export class CarrierAutocompleteComponent implements OnInit {
	isLoading = false;

	carrierCtrl = new UntypedFormControl();
	listOfCarriers: any[];

	@ViewChild('carrierInput') carrierInput: ElementRef;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;
	@Input() selectedCarrier: any = null;
	@Output() carrierSelected: EventEmitter<any> = new EventEmitter();

	constructor(
		private urlService: UrlService,
		private carrierService: CarrierService,
		public utilService: UtilService
	) {}

	ngOnInit() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedCarrier)) {
			this.carrierCtrl.setValue(this.selectedCarrier);
		}
		this.carrierCtrl.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => {
					this.isLoading = true;
				}),
				switchMap((value) => {
					console.log(value)
					if (IS_NOT_EMPTY(value) && IS_NOT_NULL_OR_UNDEFINED(value)) {
						return this.carrierService.search(this.urlService.searchCarriersUrl(value));
					} else if (
						IS_NOT_NULL_OR_UNDEFINED(this.carrierInput.nativeElement.value) &&
						IS_NOT_EMPTY(this.carrierInput.nativeElement.value)
					) {
						return;
					}
					this.carrierSelected.emit(null);
					this.isLoading = false;
				})
			)
			.subscribe(
				(carriers) => {
					this.listOfCarriers = carriers.carriers;
					this.isLoading = false;
				},
				(error) => {
					this.isLoading = false;
				}
			);
	}

	ngOnChanges() {
		if (IS_NULL_OR_UNDEFINED(this.selectedCarrier)) {
			this.carrierCtrl.setValue('');
		} else {
			this.carrierCtrl.setValue(this.selectedCarrier);
		}
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.carrierSelected.emit(event.option.value);
	}

	displayFn(carrier: any) {
		return carrier && carrier.businessName ? carrier.businessName : '';
	}
}
